import classNames from 'classnames';
import DashboardRibbon, { IDashboardRibbonProps } from '../DashboardRibbon/DashboardRibbon';
import './DashboardSingleRibbon.scss';

export interface IDashboardSingleRibbonProps extends IDashboardRibbonProps {
  className?: string | object;
}

function DashboardSingleRibbon({ theme, children, className, ...ribbonProps }: IDashboardSingleRibbonProps) {
  return (
    <DashboardRibbon theme={theme} className={classNames('dashboard-single-ribbon', theme, className)} {...ribbonProps}>
      {children}
    </DashboardRibbon>
  );
}

export default DashboardSingleRibbon;
